import { parseHubSource } from "src/utils/hubSource";

/**
 * Promotions hub data source: `ers` (legacy) or `payload` (pg-payload-cms).
 * @returns {'ers' | 'payload'}
 */
export function getPromotionsSource() {
  return parseHubSource(process.env.REACT_APP_PROMOTIONS_SOURCE);
}

export function isPayloadPromotionsSource() {
  return getPromotionsSource() === "payload";
}
